import { useQuery } from 'react-query';

import processingActivitiesApi from 'config/api/processingActivities/processingActivities';
import QUERY_KEYS from 'config/api/QUERY_KEYS';

const useProcessingActivitiesMetrics = (organizationId: number | undefined) => {
  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEYS.PROCESSING_ACTIVITIES_METRICS, organizationId],
    async () => {
      const { data: metrics } = await processingActivitiesApi.getMetrics(organizationId as number);
      return metrics;
    },
    {
      enabled: organizationId != null,
      retry: false,
    },
  );

  return {
    metrics: data,
    isLoading,
    refetch,
  };
};

export default useProcessingActivitiesMetrics;
